import axios from 'axios';

let establishments = [];
const ESTABLISHMENT_URI = '/api/bff-dashboard/private/establishments';
const COMMERCE_URI = '/api/v1/bff-establishment/private/commerce';

export const getEstablishments = token => {
  if (establishments.length > 0) return Promise.resolve(establishments);

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.get(ESTABLISHMENT_URI, headers).then(({ data }) => {
    establishments = data.map(establishment => {
      let sale_method = establishment.sale_method.split(' ')[0];
      return { ...establishment, checked: true, sale_method };
    });
    return establishments;
  });
};

export const setSelectedEstablishments = selectedEstablishments => {
  establishments = establishments.map(establishment => ({
    ...establishment,
    checked: selectedEstablishments.includes(establishment.establishment_id),
  }));

  return Promise.resolve(establishments);
};

export const getChecked = () =>
  establishments.filter(establishment => establishment.checked);

export const isAllChecked = () => getChecked().length === establishments.length;

export const getCheckedEstablishmentsIds = () =>
  getChecked().map(establishment => establishment.establishment_id);

let dataCommerce;
const getBigCommerce = token => {
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.get(COMMERCE_URI, headers).then(({ data }) => {
    return data.big_commerce;
  });
};

export const isBigCommerce = (token) =>{
  
  if (!dataCommerce) { 
    dataCommerce = getBigCommerce(token)
  }
  return dataCommerce;
} 


